<template>
	<el-row>
		<li>课程基础信息</li>
		<el-form ref="info" :model="info" style="margin:50px 50px;" label-position="right" label-width="120px">
			<el-form-item label="课程标题:" prop="lessonName" :rules="[{
				required: true,trigger: 'blur',message: '请输入课程标题'
			}]">
				<el-input placeholder="80个字" maxlength="80" style="width: 800px" v-model="info.lessonName"
					show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="文件类型:" prop="fileType" :rules="[
				{required: true,trigger: 'blur',message: '请选择文件类型'}]">
				<el-radio-group v-model="info.fileType" @change="xzLx()">
					<el-radio :label="1">视频</el-radio>
					<el-radio :label="2">音频mp3</el-radio>
					<el-radio :label="3">图文</el-radio>
				</el-radio-group>
			</el-form-item>

			<el-form-item label="上传课程:" :rules="[{
				required: true,trigger: 'blur'}]">
				<div v-if="info.fileType == 1">
					<el-upload v-if="info.video ==''" :action="uploadUrl" list-type="picture-card" :limit="1"
						:on-success="getURL" accept=".mp4" :before-upload="beforeAvatarUpload">
						<i class="el-icon-plus" />
					</el-upload>
					<div v-if="info.video !=''" style="display: flex">
						<video width="300px" height="150px" controls :src="info.video"></video>
						<div style="display: flex;align-items: center;margin-left: 10px;">
							<el-button icon="el-icon-delete" size="small" type="primary" @click='handleVideoRemove'>
							</el-button>
						</div>
					</div>
				</div>
				<div v-if="info.fileType == 2">
					<el-upload v-if="info.mp3 ==''" :action="uploadUrl" list-type="picture-card" :limit="1"
						:on-success="getURL2" accept=".mp3" :before-upload="beforeAvatarUpload2">
						<i class="el-icon-plus" />
					</el-upload>
					<div v-if="info.mp3 !=''" style="display: flex">
						<audio width="300px" height="150px" controls :src="info.mp3"></audio>
						<div style="display: flex;align-items: center;margin-left: 10px;">
							<el-button icon="el-icon-delete" size="small" type="primary" @click='handleAudioRemove'>
							</el-button>
						</div>
					</div>
				</div>
				<div v-if="info.fileType == 3" style="width: 700px;">
					<wangeditor v-model="info.wangeditor" />
				</div>
			</el-form-item>
			<el-form-item label="本节是否免费:" prop="free" :rules="[{
				required: true,trigger: 'blur',message: '请选择本节是否免费'
			}]">
				<el-radio-group v-model="info.free">
					<el-radio :label="0">免费观看</el-radio>
					<el-radio :label="1">付费观看</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="随堂测试:" prop="testType" :rules="[{
				required: true,trigger: 'blur',message: '请选择随堂测试'
			}]">
				<el-radio-group v-model="info.testType">
					<el-radio :label="0">无</el-radio>
					<el-radio :label="1">考试</el-radio>
					<el-radio :label="2">作业</el-radio>
					<el-radio :label="3">实践</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="medium" @click="queren()">
					{{this.$route.query.cz == 2 ? "修改" : "确认发布"}}
				</el-button>
			</el-form-item>
		</el-form>
	</el-row>
</template>

<script>
	import httpClient from '../../../util/request.js';
	import wangeditor from "../../../components/wangEditor/wangEditor.vue";
	export default {
		components: {
			wangeditor,
		},
		data() {
			return {
				uploadUrl: httpClient.imgUrl,
				info: {
					video: '',
					mp3: '',
					urlLength: '',
					urlLength2: '',
					lessonName: '', //课时名称
					lessonInfo: '', //内容
					fileType: 1, //课程类型
					free: '', //是否付费
					testType: "", //随堂测验类型
				},
			}
		},

		methods: {
			queren() {
				let length = ''
				if (this.info.fileType == 1) {
					this.info.lessonInfo = this.info.video
					length = this.info.urlLength.duration
				}
				if (this.info.fileType == 2) {
					this.info.lessonInfo = this.info.mp3
					length = this.info.urlLength2.duration
				}
				if (this.info.fileType == 3) {
					this.info.lessonInfo = this.info.wangeditor
					length = ''
				}
				console.log(this.info);
				if (this.info.lessonInfo == '') {
					this.$message.error('请上传课程内容')
				} else {
					this.$refs.info.validate((valid) => {
						if (valid) {
							if (this.$route.query.cz == 2) {
								this.$http.post(`/api/course/clrCourse/updateLesson`, {
									"lessonId": this.$route.query.lessonId,
									"lessonName": this.info.lessonName, //（课时名称）
									"chapterId": this.$route.query.chapterId, //（所属章节ID）
									"courseId": this.$route.query.courseId, //（所属课件ID）
									"lessonInfo": this.info.lessonInfo, //（课程内容）
									"fileType": this.info.fileType, //（内容类型）
									"free": this.info.free, //（免费/付费）
									"testType": this.info.testType, //（随堂测验类型）
									"length": length
								}).then(res => {
									console.log(res);
									if (res.data.status == 0) {
										this.$message.success(res.data.data)
										this.$router.push({
											path: './viewCourseware',
											query: {
												id: this.$route.query.courseId
											}
										})
									} else {
										this.$message.success(res.data.msg)
									}
								})
							} else {
								this.$http.post(`/api/course/clrCourse/addLesson`, {
									"lessonName": this.info.lessonName, //（课时名称）
									"chapterId": this.$route.query.chapterId, //（所属章节ID）
									"courseId": this.$route.query.courseId, //（所属课件ID）
									"lessonInfo": this.info.lessonInfo, //（课程内容）
									"fileType": this.info.fileType, //（内容类型）
									"free": this.info.free, //（免费/付费）
									"testType": this.info.testType, //（随堂测验类型）
									"length": length
								}).then(res => {
									console.log(res);
									if (res.data.status == 0) {
										this.$message.success(res.data.data)
										this.$router.push({
											path: './viewCourseware',
											query: {
												id: this.$route.query.courseId
											}
										})
									} else {
										this.$message.success(res.data.msg)
									}
								})
							}
						}
					})
				}
			},
			xzLx() {
				console.log(this.info.fileType);
				if (this.info.fileType == 1) {
					this.info.mp3 = ''
					this.info.wangeditor = ''
				}
				if (this.info.fileType == 2) {
					this.info.video = ''
					this.info.wangeditor = ''
				}
				if (this.info.fileType == 3) {
					this.info.mp3 = ''
					this.info.video = ''
				}
			},
			handleVideoRemove() {
				this.info.video = ''
				this.info.urlLength = ''
			},
			handleAudioRemove() {
				this.info.mp3 = ''
				this.info.urlLength2 = ''
			},
			//视频
			getURL(res, file, fileList) {
				// console.log(file);
				var binaryData = [];
				// 传入file中raw
				binaryData.push(file.raw);
				//获取视频或者音频时长
				var fileurl = URL.createObjectURL(new Blob(binaryData));
				//经测试，发现audio也可获取视频的时长
				var audioElement = new Audio(fileurl);
				audioElement.addEventListener("loadedmetadata", function(_event) {
					//audioElement.duration就是视频时长
					file.duration = audioElement.duration;
					let time = file.duration
					let h = Math.floor(time / 3600)
					let m = Math.floor(time / 60)
					let s = Math.floor(time % 60)
					if (h < 10) {
						h = '0' + h
					}
					if (m < 10) {
						m = '0' + m
					}
					if (s < 10) {
						s = '0' + s
					}
					file.Length = h + ':' + m + ':' + s
				});
				this.info.urlLength = file
				this.info.video = res.data
			},
			//音频
			getURL2(res, file, fileList) {
				// console.log(file);
				var binaryData = [];
				// 传入file中raw
				binaryData.push(file.raw);
				//获取视频或者音频时长
				var fileurl = URL.createObjectURL(new Blob(binaryData));
				//经测试，发现audio也可获取视频的时长
				var audioElement = new Audio(fileurl);
				audioElement.addEventListener("loadedmetadata", function(_event) {
					//audioElement.duration就是视频时长
					file.duration = audioElement.duration;
					let time = file.duration
					let h = Math.floor(time / 3600)
					let m = Math.floor(time / 60)
					let s = Math.floor(time % 60)
					if (h < 10) {
						h = '0' + h
					}
					if (m < 10) {
						m = '0' + m
					}
					if (s < 10) {
						s = '0' + s
					}
					file.Length = h + ':' + m + ':' + s
				});
				this.info.urlLength2 = file
				this.info.mp3 = res.data
			},
			beforeAvatarUpload(file) {
				// console.log(file)
				let type = file.type
				if (type.substring(type.length - 4) == "/mp4") {} else {
					this.$message.error('请上传MP4格式的视频')
					return false
				}
			},
			beforeAvatarUpload2(file) {
				// console.log(file)
				// let type = file.type
				// // console.log(type.substring(type.length - 4));
				// if (type.substring(type.length - 4) == "mpeg") {} else {
				// 	this.$message.error('请上传MP3格式的音频')
				// 	return false
				// }
			},
		},
		mounted() {
			if (this.$route.query.cz == 2) {
				let newdata = this.$route.query
				console.log(newdata);
				this.info.lessonName = newdata.lessonName
				if (newdata.fileType == 1) {
					this.info.video = newdata.lessonInfo
				}
				if (newdata.fileType == 2) {
					this.info.mp3 = newdata.lessonInfo
				}
				if (newdata.fileType == 3) {
					this.info.wangeditor = newdata.lessonInfo
				}
				this.info.fileType = newdata.fileType - 0
				this.info.free = newdata.free - 0
				this.info.testType = newdata.testType - 0
			}
		},
		created() {
			console.log(httpClient);
		}
	}
</script>

<style scoped>
</style>
